import { render, staticRenderFns } from "./Filterable.vue?vue&type=template&id=359d960a&scoped=true&"
import script from "./Filterable.vue?vue&type=script&lang=js&"
export * from "./Filterable.vue?vue&type=script&lang=js&"
import style0 from "./Filterable.vue?vue&type=style&index=0&id=359d960a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "359d960a",
  null
  
)

export default component.exports